export default "__VITE_ASSET__CWzauDjS__"